import { createBlock } from 'factories/block';
import { Block } from 'factories/block';
import { InteractionProps, reverse } from './interaction';
import { createLayout } from 'factories/layout';
import { createMediaBlock } from './media';
import { createContinueBtn } from './continueBtn';
import uuid from 'uuidv4';
import { getSId } from '../utils';

export type ImageInteractionProps = InteractionProps & {};

const createAssessmentIntroduction = (props?: {}) => {
  return createBlock('AssessmentIntroduction', [], { props: {} });
};

const createAssessmentQuestion = (props?: {}) => {
  return createBlock('AssessmentQuestion', [], { props: {} });
};

const createAssessmentResults = (props?: {}) => {
  return createBlock('AssessmentResults', [], { props: {} });
};

export const createAssessmentInteractionBlock = props => {
  return createBlock(
    'Interaction',
    [
      createBlock('Assessment', [
        createAssessmentIntroduction(),
        createAssessmentQuestion(),
        createAssessmentResults(),
      ]),

      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(props.style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        type: 'Assessment',
        name: props.name,
        sId: getSId('interaction'),
        style: props.style || {},
      },
      meta: {
        subType: 'Assessment',
      },
    }
  );
};

export const interactionConfig = {};
